<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" :svg="svgMade" />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <view-shop v-model="cardTexts" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <v-row class="row justify-center" no-gutters>
                <v-col class="pa-2" cols="12">
                  <p class="ma-0">محصولات و اطلاعات</p>
                </v-col>
                <v-col class="pa-2" cols="12">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="cardTexts.visitName"
                      :disabled="e6 > 2"
                      :error-messages="errors.title"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام فروشگاه آنلاین"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName-cardTexts`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام فروشگاه آنلاین"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="rowinfo">
                <v-btn
                  :disabled="e6 > 2"
                  class="mb-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-clearDefaults-cardTexts`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="حذف اطلاعات پیشفرض"
                />
              </div>
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6++"
                  v-text="'ادامه'"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >تنظیمات محتوا</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo2"
                :data="cardTexts"
                flat
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6--" />
                </div>

                <div class="col-md-6">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr"
                    v-text="'ثبت درخواست'"
                  />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-download-Qr`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="px-5">
            <download-file
              v-if="showDialog"
              :data="{ theme: '', data: cardTexts }"
              :svg="svgMade"
              :visit-name="cardTexts.visitName"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, debounce, RobotAxios } from "@/main";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import DownloadFile from "@/view/pages/qrland/downloadFile";
import ViewShop from "@/view/pages/businessPage/pages/shopPage/viewShop";

export default {
  name: "createShop",

  components: {
    ViewShop,
    DownloadFile,
    QrMaker,
    QrManagement,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "createShop-cb",

      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "bannerSelector",
          value: "",
          title: "آپلود بنر",
          subtitle: "",
          icon: "image",
          model: "banner",
        },
        {
          name: "textCards",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "Product",
          value: "",
          title: "ایجاد محصول",
          subtitle: "",
          icon: "sign-yield",
          model: "product",
          arm: [],
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        { name: "Blog", value: "", title: "بلاگ", subtitle: "", icon: "text" },
        {
          name: "Service",
          value: "",
          title: "خدمات",
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: "سوالات متداول",
          subtitle: "",
          icon: "help",
          model: "faq",
        },
      ],
      specialInfo2: [
        {
          name: "PicSelector",
          value: "",
          title: "گالری عکس",
          subtitle: "",
          icon: "image",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          subtitle: "",
          icon: "video",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "گالری پی دی اف ",
          subtitle: "",
          icon: "file",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "reply",
          model: "FeedBack",
        },
        {
          name: "Counter",
          value: "",
          title: "شمارنده معکوس",
          subtitle: "",
          icon: "timer",
          model: "Counter",
        },
        {
          name: "consultation",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultation",
        },
        {
          name: "ServiceSection",
          value: "",
          title: "ایجاد بخش",
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: "موفقیت های بدست آمده",
          subtitle: "",
          icon: "post",
          model: "CounterService",
        },
        {
          name: "Personnel",
          value: "",
          title: "اعضای تیم",
          subtitle: "",
          icon: "timer",
          model: "personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: "تایم کاری",
          subtitle: "",
          icon: "timer",
          model: "WorkSheet",
        },
      ],
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: "",
      cardTexts: {
        banner: {
          gallery: [
            {
              name: "",
              images: [
                {
                  name: "28",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 17534,
                },
                {
                  name: "32",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 17535,
                },
              ],
            },
          ],
        },
        consultation: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          items: {
            name: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام",
            },
            surname: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام خانوادگی",
            },
            phone: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "شماره موبایل",
            },
            mail: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "ایمیل",
            },
            address: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "آدرس",
            },
            nationalId: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "کدملی",
              verify: "correct",
            },
            location: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "لوکیشن",
            },
            custom: {
              is_active: false,
              type: "optional",
              value: "",
              format: "select",
              extra: {
                label: "",
                options: [],
              },
            },
            description: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "توضیحات",
            },
          },
        },
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        personnel: {
          items: [],
        },
        WorkSheet: {
          items: {
            saturday: {
              name: "شنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            sunday: {
              name: "یکشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            monday: {
              name: "دوشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            tuesday: {
              name: "سه‌شنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            wednesday: {
              name: "چهارشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            thursday: {
              name: "پنجشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "12:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            friday: {
              name: "جمعه",
              shift: [{}, {}],
            },
          },
        },
        Counter: {
          title: "متفاوت خواهیم شد...",
          description:
            "در مسیری درست، همیشه کوشا هستیم تا بهترین خود باشیم >>> برای شما",
          until: "2026-03-21 00:00:00",
          type: "countdown_2",
        },
        product: {
          title: "محصولات",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
          onlineShop: true,
        },
        specialCategories: {
          title: "فروش ویژه",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        visitName: "",
        organizationName: "کیوآر لند",
        subOrgan: "فروشگاه آنلاین شما 15 دقیقه ای آمادست!",
        userName: "خانم صفدریان",
        workField: "مدیریت فروش",
        phoneNumber: [
          {
            number: "90007425",
          },
          {
            number: "02191017077",
          },
          {
            number: "09999903535",
          },
        ],
        extraFields: [
          {
            icon: "",
            name: "",
            value:
              "مشتری عزیز شما می توانید از سایر فروشگاه های آنلاین ما نیز خرید کنید:",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت دیوار",
            link: "www.divar.ir",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت دیجی کالا",
            link: "www.digikala.com",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت باسلام",
            link: "www.basalam.com",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت ترب",
            link: "www.torob.com",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت ایمالز",
            link: "www.emalls.ir",
          },
        ],
        companyNumber: "02191017077",
        email: "9100terminalads@gmail.com",
        fax: "02191016066",
        location:
          "تهران، خیابان شریعتی ، بعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
        city: "",
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.terminalads.com",
        socialMedia: {
          address: [
            {
              label: "آدرس",
              text: "لینک سایت مورد نظر را وارد نمایید",
              pattern: "",
              prefix: "URL",
              url: "qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
          ],
          instagram: [
            {
              label: "اینستاگرام",
              text: "نام کاربری خود را وارد نمایید",
              pattern: "https://instagram.com/",
              prefix: "@",
              url: "terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
            },
          ],
          whatsapp: [
            {
              label: "واتساپ",
              text: "+989123456789",
              pattern: "https://wa.me/",
              prefix: "mdi-phone",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
            },
          ],
        },
        aboutUs:
          'با افتخار فروشگاه‌سازی حرفه‌ای و کارآمد را برای کسب‌وکار‌های آنلاین ارائه داده ایم.\nبدون نیاز به دانش فنی، به‌ صورت کاملاً رایگان، می‌توانید فروشگاه اینترنتی خود را ایجاد کنید.\nما به شما امکاناتی مانند مدیریت محصولات، پرداخت آنلاین، و پیگیری سفارشات را فراهم می‌کنیم.\nهمچنین، پشتیبانی اختصاصی و راهکارهای جذب مشتریان را نیز ارائه می‌دهیم.\n\nاگر نیاز به تنظیمات خاصی دارید یا سایر جزئیات را می‌خواهید، \nلطفاً به نیازهای کسب‌وکار خود بپردازید و متن "درباره ما" را به‌صورت مناسب تغییر دهید.',
        copyright: "تمامی حقوق این سایت متعلق به کیوآر لند می باشد.",
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #C22121FF, #130000FF)",
            text: "#fff",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",

        },
        Blog: {
          title: null,
          description: null,
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        CounterService: {
          title: "دستاوردهای مجموعه ما",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          items: [
            {
              type: "percent",
              counter: "97",
              name: "رضایت مشتریان",
              icon: "mdi-account",
              link: "",
            },
            {
              type: "percent",
              counter: "4",
              name: "کمترین بازگشتی",
              icon: "mdi-backup-restore",
              link: "",
            },
            {
              type: "number",
              counter: "20000",
              name: "مشتری وفادار",
              icon: "mdi-account-box-multiple",
              link: "",
            },
            {
              type: "number",
              counter: "145485",
              name: "سفارش ارسال شده",
              icon: "mdi-archive-check",
              link: "",
            },
          ],
        },
        PicSelector: {
          title: null,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "از ویدئوهای مجموع ما دیدن فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        ServiceSection: {
          title: null,
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          items: [
            {
              section: {
                title: "",
                text: null,
                button: {
                  show: false,
                  title: "یک خرید راحت",
                  icon: "mdi-monitor-cellphone",
                  background:
                    "linear-gradient(to right , #1AD0D8FF, #2115A7FF)",
                  color: "#ffffffff",
                  link: "https://my.qrland.ir/003#/",
                  target: "_blank",
                },
                text_position: "left",
                object: {
                  type: "image",
                  url: "",
                },
              },
            },
          ],
        },
        faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            gallery: [
              {
                name: "گالری عکس",
                images: [],
              },
            ],
          },
          sectionColor: {
            backGround: "linear-gradient(to right , #FF000062, #FF000075)",
            text: "#fff",
          },
          items: [
            {
              question: "1. چطوری می تونم سفارش خودم رو ثبت کنم ؟",
              answer: "کافیست محصولات مورد نظر خود را به سبد خرید اضافه کنید.",
            },
            {
              question: "2. چگونه می توانم در سایت ثبت نام کنم؟",
              answer:
                'کافیست بر روی دکمه "ورود" کلیک کنید و پس از وارد کردن شماره همراه، کد پیامک شده را نیز وارد کنید.',
            },
            {
              question:
                "3. پس از اینکه سفارشم رو ثبت کردم چقدر طول می کشه به دستم برسه؟",
              answer: "در سریع ترین زمان ممکن سفارش شما ارسال خواهد شد.",
            },
            {
              question: "4. هزینه ارسال سفارش چقدر هست؟",
              answer: "هزینه ارسال سفارش نسبت به آدرس شما متغییر خواهد بود.",
            },
            {
              question:
                "5. آیا می تونم بعد از ثبت سفارش، محصولمو تغییر بدم یا کنسل کنم ؟",
              answer: "خیر.\nامکان تغییر یا لغو وجود ندارد.",
            },
          ],
        },
        Service: {
          title: "بهترین ها را برای شما به ارمغان آورده ایم...",
          slider: false,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما برای ما مهم است",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "emoji",
          items: [
            {
              question: "آیا از کیفیت کالاها رضایت داشتید؟",
              answer: "",
              value: null,
              description: true,
              forceDesc: false,
            },
            {
              question: "کیفیت بسته بندی را چگونه ارزیابی می کنید؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "آیا از تنوع کالاها راضی بودید؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "آیا از تخفیفات این فروشگاه هم بهره ‎مند شده ‎اید؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "برای بهبود تجربه‎ خرید از این فروشگاه چه پیشنهادی دارید؟",
              answer: "",
              value: null,
              description: true,
              forceDesc: true,
            },
          ],
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
        pdf: null,
        blog: [],
        service: [
          {
            title: "پست 1",
            content: "ارسال سریع سفارش",
            icon: "mdi-truck-fast",
            gallery: [
              {
                name: "",
                images: [],
              },
            ],
            color: null,
          },
          {
            title: "پست 2",
            content: "امکان پرداخت در محل",
            icon: "mdi-account-credit-card",
            gallery: [
              {
                name: "",
                images: [],
              },
            ],
            color: null,
          },
          {
            title: "پست 3",
            content: "ضمانت اصالت کالا",
            icon: "mdi-shield-check",
            gallery: [
              {
                name: "",
                images: [],
              },
            ],
            color: null,
          },
        ],
        gallery: [
          {
            name: "گالری عکس",
            images: [
              {
                name: "34",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17536,
              },
              {
                name: "35",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17537,
              },
              {
                name: "36",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17538,
              },
            ],
          },
        ],
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                file_link:
                  "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                description: "",
                link: "",
                id: 15,
              },
            ],
          },
        ],
      },
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },
  computed: {
    imageurl_1() {
      return this.$cdnUrl + "/upload/6676afc9ddf26.webp";
    },
    imageurl_2() {
      return this.$cdnUrl + "/upload/6676afd1cdc70.webp";
    },
    imageurl_3() {
      return this.$cdnUrl + "/upload/666d5c59898ed.webp";
    },
    imageurl_4() {
      return this.$cdnUrl + "/upload/6676afd6ecb43.webp";
    },
    imageurl_5() {
      return this.$cdnUrl + "/upload/6676afdcdc7cb.webp";
    },
    imageurl_6() {
      return this.$cdnUrl + "/upload/6676afe735707.webp";
    },
  },

  mounted() {
    this.cardTexts.banner.gallery[0].images[0].url = this.imageurl_1;
    this.cardTexts.banner.gallery[0].images[1].url = this.imageurl_2;
    this.cardTexts.ServiceSection.items[0].section.object.url = this.imageurl_3;
    this.cardTexts.gallery[0].images[0].url = this.imageurl_4;
    this.cardTexts.gallery[0].images[1].url = this.imageurl_5;
    this.cardTexts.gallery[0].images[2].url = this.imageurl_6;

    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: "SCAN ME",
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });

    Bus.$on("eyeStyle", (value) => {
      this.eyeStyle = value;
    });

    Bus.$on("qrStyle", (value) => {
      this.qrStyle = value;
    });
  },

  methods: {
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "bShop",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify(this.cardTexts),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post(
          "qr/template",
          {
            qr: obj,
            type: "bShop",
            title: this.cardTexts.visitName,
          },
          {
            timeout: 100000,
          },
        )
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("صفحه کاری شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          if (response?.data?.errors)
            Object.values(response.data.errors).forEach((err) =>
              this.$toast.error(err.toString()),
            );
          this.errors = response.data.errors;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.cardTexts = {
        pdf: undefined,
        banner: undefined,
        blog: undefined,
        service: undefined,
        video_gallery: undefined,
        gallery: undefined,
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        visitName: "",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: null }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: null,
        email: null,
        fax: null,
        location: null,
        city: null,
        codePostal: null,
        province: null,
        country: null,
        website: null,
        socialMedia: {},
        aboutUs: null,
        copyright: null,
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: null,
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",

        },
        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        PicSelector: {
          title: "گالری عکس",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            images: [],
          },
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Service: {
          title: "خدمات",
          slider: false,
          description:
            "با استراتژیست بازاریابی دیجیتال ما، شرکت خود را در مسیر درست قرار دهید",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "",
          items: [],
        },
        faqs: [],
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      };
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
